import { ClipboardList } from "lucide-react";
import { PortalLoginForm } from "@/components/auth/PortalLoginForm";
import { ROUTES } from "@/constants/routes";

export default function StaffLogin() {
    return (
        <PortalLoginForm
            portal="staff"
            title="Staff"
            subtitle="Order picking, packing & fulfilment."
            homePath={ROUTES.staffDashboard}
            accent="bg-amber-600"
            icon={<ClipboardList className="h-5 w-5" />}
            testId="staff-login-page"
        />
    );
}
